import { render, staticRenderFns } from "./MyTransaction.vue?vue&type=template&id=f8a181e6&"
import script from "./MyTransaction.vue?vue&type=script&lang=js&"
export * from "./MyTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports